import hasWebpSupport from '@helpers/misc/hasWebpSupport'
import {useApolloQuery} from '@packages/apollo-hooks'
import gql from 'graphql-tag'

import {
  getProductDetailsWeb_cached,
  getProductDetailsWeb_cachedVariables
} from './__generated__/getProductDetailsWeb_cached'
import useSetOutOfStock from './useSetOutOfStock'

export default function useProduct({productId, menuId, storeId, deliverAt, websiteId}) {
  const {product} = useApolloQuery<
    getProductDetailsWeb_cachedVariables,
    getProductDetailsWeb_cached
  >({
    query: gql`
      query getProductDetailsWeb_cached(
        $productId: ID
        $menuId: ID
        $format: String
        $websiteId: ID
      ) {
        product(productId: $productId, websiteId: $websiteId) {
          _id
          name
          description
          altImg
          titleImg
          urlVideo
          images {
            _id
            url
            imageLarge: resizedURL(width: 1200, height: 1200, format: $format)
          }
          categories {
            _id
            name
            internalName
          }
          isOutOfStock
          maxPurchaseQuantity
          modifiers {
            _id
            name
            description
            min
            max
            optional
            isImageModifier
            options {
              _id
              name
              max
              availabilityAt(menuId: $menuId) {
                menuId
                price
                available
              }
              image {
                _id
                url
                imageLarge: resizedURL(width: 300, height: 300, format: $format)
              }
            }
          }
          availabilityAt(menuId: $menuId) {
            available
            basePrice
            finalPrice
            notAvailableMessage
          }
        }
      }
    `,
    variables: {
      websiteId,
      productId,
      menuId,
      format: hasWebpSupport() ? 'webp' : 'jpeg'
    }
  })

  const {outOfStockModifierOptions, isOutOfStock} = useSetOutOfStock({
    product,
    websiteId,
    storeId,
    deliverAt
  })

  const newModifier = product.modifiers.map(modifier => ({
    ...modifier,
    options: modifier.options.map(option => {
      return {
        ...option,
        isOutOfStock: outOfStockModifierOptions.includes(option._id)
      }
    })
  }))

  return {
    ...product,
    isOutOfStock,
    modifiers: newModifier
  }
}
